import script from "./Consultant.vue?vue&type=script&setup=true&lang=js"
export * from "./Consultant.vue?vue&type=script&setup=true&lang=js"

import "./Consultant.vue?vue&type=style&index=0&id=03f9926a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f9926a"]])

export default __exports__